import { Settings } from 'luxon'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  Settings.defaultLocale = config.public.locale
})
